module.exports = __webpack_public_path__ + "img/platform-lose.3e9acf99.png";